const pendingWaits = new Map<string, Promise<void>>()

const waitForMatch = (query: string, list: MediaQueryList): Promise<void> =>
    new Promise(resolve => {
        const handleChange = (event: MediaQueryListEvent) => {
            if (!event.matches) {
                return
            }

            list.removeEventListener('change', handleChange)
            pendingWaits.delete(query)
            resolve()
        }

        list.addEventListener('change', handleChange)
    })

export const whenMediaMatches = (query: string): Promise<void> => {
    const list = window.matchMedia(query)

    if (list.matches) {
        return Promise.resolve()
    }

    const pending = pendingWaits.get(query) ?? waitForMatch(query, list)
    pendingWaits.set(query, pending)

    return pending
}
